import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=380c2c78&"
import script from "./Maintenance.vue?vue&type=script&lang=js&"
export * from "./Maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380c2c78')) {
      api.createRecord('380c2c78', component.options)
    } else {
      api.reload('380c2c78', component.options)
    }
    module.hot.accept("./Maintenance.vue?vue&type=template&id=380c2c78&", function () {
      api.rerender('380c2c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Maintenance.vue"
export default component.exports